import MessageConversation from '@efdigital/ll-xceed-v2/components/coaching/messaging/message-conversation.gts';
import type { CoachingCoachMessagesConversationModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/messages/conversation';
import type { TOC } from '@ember/component/template-only';

interface MessagesConversationSignature {
  Args: {
    model: CoachingCoachMessagesConversationModel;
    controller: unknown;
  };
}

<template>
  <MessageConversation
    @conversation={{@model.conversation}}
    @role="coach"
    class="h-100 w-100"
  />
</template> satisfies TOC<MessagesConversationSignature>;
